module.exports = __webpack_public_path__ + "static/media/ic_arrow_down_focus.d0f64d37.svg";